import React from 'react';
import PropTypes from 'prop-types';

import Grid from "@mui/material/Grid";

import InfoTooltipIcon from "components/CustomTooltip/InfoTooltipIcon";

import {black500} from "assets/jss/main";

Detail.propTypes = {
    name: PropTypes.string,
    value: PropTypes.any,
    tooltipMessageId: PropTypes.string
};

function Detail({name, value, tooltipMessageId = null}) {
    return (
        <Grid
            item
            container
            justifyContent='space-between'
            sx={{
                fontSize: '14px',
                fontWeight: 400,
                color: black500
            }}
        >
            <Grid item>
                {name}:
            </Grid>
            <Grid item sx={{display: 'flex', alignItems: 'center'}}>
                {value}
                {tooltipMessageId !== null && (
                    <span style={{display: 'flex', marginLeft: '8px'}}><InfoTooltipIcon titleId={tooltipMessageId} /></span>
                )}
            </Grid>
        </Grid>
    );
}

export default Detail;
